<div class="receipt-page">
  <div class="receipt-sheet">
    <!-- Loading -->
    <div class="receipt-loading" *ngIf="step() === 'loading'" role="status" aria-live="polite">
      <span class="receipt-spinner" aria-hidden="true"></span>
      <p class="receipt-loading-text">Loading your prepaid package…</p>
    </div>

    <!-- Pass -->
    <div class="receipt-card" *ngIf="step() === 'ready' && view() as v">
      <header class="receipt-brand">
        <div class="receipt-brand-copy">
          <h1 class="receipt-shop-name" *ngIf="v.shopName">{{ v.shopName }}</h1>
          <p class="receipt-branch" *ngIf="v.packageName">{{ v.packageName }}</p>
        </div>
      </header>

      <section class="prepaid-pass-qr-block" aria-live="polite">
        <h2 class="prepaid-pass-headline">{{ v.headline }}</h2>
        <p class="prepaid-pass-body">{{ v.body }}</p>
        <img
          *ngIf="v.qrCode"
          class="prepaid-pass-qr"
          [src]="v.qrCode"
          alt="QR code to redeem your prepaid wash"
        />
        <a
          *ngIf="v.qrCode"
          class="prepaid-pass-download"
          [href]="v.qrCode"
          [attr.download]="v.downloadFileName"
          >Download QR code</a
        >
      </section>

      <dl class="receipt-details">
        <div class="receipt-row" *ngFor="let item of v.items">
          <dt class="receipt-row-label">{{ item.name }}</dt>
          <dd class="receipt-row-value">{{ item.line }}</dd>
        </div>
        <div class="receipt-row" *ngIf="v.validTill">
          <dt class="receipt-row-label">Valid till</dt>
          <dd class="receipt-row-value">{{ v.validTill }}</dd>
        </div>
        <div class="receipt-row" *ngIf="v.orderNumber">
          <dt class="receipt-row-label">Order number</dt>
          <dd class="receipt-row-value">{{ v.orderNumber }}</dd>
        </div>
      </dl>
    </div>

    <!-- Error -->
    <div class="state-block" *ngIf="step() === 'error'">
      <h2 class="state-headline">Prepaid package unavailable</h2>
      <p class="state-body" role="alert">{{ errorMessage() }}</p>
    </div>
  </div>
</div>
